import httpClient from '../utils/httpClient';

export const searchJewellery = async (searchParams) => {
    const response = await httpClient.post('/api/Diamond/Search', searchParams);
    return response.data;
};

export const StyleJewelleryDetailData = async (requestParams) => {
    const response = await httpClient.post('/StyleJewellery/StyleJewelleryDetailData', requestParams);
    return response.data;
};

export const GetJewelleryFilterMenu = async (userParams) => {
    const response = await httpClient.post('/api/Jewellery/GetJewelleryFilterMenu', userParams);
    return response.data;
};

export const getJewelleryParameter = async (requestParams) => {
    const response = await httpClient.post('/api/Jewellery/GetJewelleryParameter', requestParams);
    return response.data;
};

export const StyleSearch = async (requestParams) => {
    const response = await httpClient.post('/StyleJewellery/StyleSearch', requestParams);
    return response.data;
};

export const getSimilarJewelleryProductData = async (requestParams) => {
    const response = await httpClient.post('/api/Jewellery/GetSimilarJewelleryProductData', requestParams);
    return response.data;
};

export const getCompareJewelleryProductData = async (requestParams) => {
    const response = await httpClient.post('/api/Jewellery/GetCompareJewelleryProductData', requestParams);
    return response.data;
};

export const newArrivalsJewellery = async (searchParams) => {
    const response = await httpClient.post('/api/Jewellery/NewArrivalsJewellery', searchParams);
    return response.data;
};

export const StyleAddToCart = async (params) => {
    const response = await httpClient.post(`/StyleJewellery/style-add-to-cart`, params);
    return response.data;
};

export const StyleGetCartCount = async (params) => {
    const response = await httpClient.post(`/StyleJewellery/style-get-cart-count`, params);
    return response.data;
};


export const TransferBasket = async (transferParams) => {
    const response = await httpClient.post('/StyleJewellery/TransferBasket', transferParams);
    return response.data;
};

export const GetBasketData = async (requestParams) => {
    const response = await httpClient.post('/StyleJewellery/GetBasketData', requestParams);
    return response.data;
};

export const GetCheckOutData = async (requestParams) => {
    const response = await httpClient.post('/StyleJewellery/GetCheckOutData', requestParams);
    return response.data;
};

export const ConfirmOrder = async (requestParams) => {
    const response = await httpClient.post('/StyleJewellery/ConfirmOrder', requestParams);
    return response.data;
};

export const GetMyOrderList = async (requestParams) => {
    const response = await httpClient.post('/StyleJewellery/GetMyOrderList', requestParams);
    return response.data;
};

export const GetMyOrderDetail = async (requestParams) => {
    const response = await httpClient.post('/StyleJewellery/GetMyOrderDetail', requestParams);
    return response.data;
};


export const ShareProductData = async (userParams) => {
    const response = await httpClient.post('/StyleJewellery/ShareProductData', userParams);
    return response.data;
};
